import * as types from './mutation-types'
import { cashierClient } from '@/service/apiClients'

export default {
  async getCasheriers ({ rootState, commit }) {
    try {
      const { data: cashiers } = await cashierClient.get(`/users/${rootState.userModule.uid}/cashiers`)
      commit(types.SET_CASHIER_LIST, cashiers)
    } catch (e) {
      console.error(e)
    }
  }
}
